import React from "react";

import { css } from "@oddcommon/utils";
import styles from "./SideNote.module.scss";

export default function SideNote({ className, ...props }) {
  return <div className={css(styles.base, className)} {...props} />;
}
